import { createFileRoute, Outlet } from "@tanstack/react-router";
import PolicyEditorLayout from "src/routes/_authed/portal/-components/moderation-policies/PolicyEditorLayout";

export const Route = createFileRoute("/_authed/portal/org_{$orgKey}/moderation-policies/$policyId")(
  {
    component: PolicyRoute,
  },
);

/** Holds the policy's draft across its overview and category pages. */
function PolicyRoute() {
  const { policyId } = Route.useParams();
  return (
    <PolicyEditorLayout key={policyId} policyId={policyId}>
      <Outlet />
    </PolicyEditorLayout>
  );
}
